/**
 * Seitentitel je Route (A3-21). Bis WP6 hiess jeder Tab "FeedOptimizer.AI",
 * sechs offene Tabs waren nicht zu unterscheiden, und Screenreader meldeten
 * beim Seitenwechsel nichts. Die Namen sind dieselben wie in der
 * Seitenleiste (`AppSidebar.tsx`), damit Tab, Leiste und H1 dieselbe Sprache
 * sprechen.
 */
export const APP_TITLE = 'FeedOptimizer.AI';

const ROUTE_TITLE_KEYS: Record<string, string> = {
  '/': 'nav.feedCheck',
  '/workbench': 'nav.workbench',
  '/performance': 'nav.performance',
  '/roadmap': 'nav.roadmap',
  '/pricing': 'nav.plans',
  '/settings': 'nav.settings',
};

export function documentTitleFor(pathname: string, t: (key: string) => string): string {
  const key = ROUTE_TITLE_KEYS[pathname];
  return key ? `${t(key)} · ${APP_TITLE}` : APP_TITLE;
}
